<!-- <div class="container-fluied card card-header" *ngIf="pannerDisplay" > -->
<div class="container-fluied active border mt-1" *ngIf="pannerDisplay" [class.active]="bannerCollapse">
    <!-- by abood -->
    <!-- <div class="container-fluied card card-header" *ngIf="pannerDisplay" [class.active]="bannerCollapse" (click)="collapsing()" > -->
    <i class="fas fa-arrows-alt-v" (click)="collapsing()"></i>
    <!-- <i class="fas fa-tint" (click)="addPatientBloodType(patient)" placement="right" displayType="topClassBlock" [ngbPopover]="popContent" #popover="ngbPopover"></i> -->
    <ng-template #popContent>
        <div class="container-fluid py-3">
            <div>
                <div class="form-group">
                    <sanabel-selectize appcode="1023" [disabled]="true" [(ngModel)]="patientCode"></sanabel-selectize>
                </div>
                <div class="form-group">
                    <sanabel-selectize appcode="24" [tabindex]="35" [(ngModel)]="patientBloodTypeData.bloodGroup">
                    </sanabel-selectize>
                </div>
                <div class="form-group">
                    <label class="small">RH</label>
                    <sanabel-selectize appcode="290" [tabindex]="34" [simpleView]="true"
                        [(ngModel)]="patientBloodTypeData.rhValue"></sanabel-selectize>
                </div>

                <div class="text-center">
                    <button type="submit" class="btn btn-primary rounded-0 btn-sm" style="letter-spacing: 1px;"
                        (click)="saveData(popover);">{{'SAVE' | translate}}</button>
                </div>
            </div>
        </div>
    </ng-template>


    <!--  -->
    <div class="pb_content container-fluid">
        <div class="row">

            <div class=" img_div" style=" width: 6%;">
                <div *ngIf="patient.gender==1">
                    <i class="fa fa-male" style="font-size: 22px;" aria-hidden="true"></i>
                    <span> Male </span>
                </div>
                <div *ngIf="patient.gender==2">
                    <i class="fa fa-female" style="font-size: 22px;" aria-hidden="true"></i>
                    <span> Female </span>
                </div>
                <!-- <div class="p_image h-100 d-flex align-items-center justify-content-left">
                   
                    <img class="img-thumbnail img-circle" src="../../../assets/images/patient .jpg" alt="">
                </div> -->
            </div>

            <div class="row col left_banner">

                <div class="col p_name font-weight-bold text-primary d-flex align-items-center">
                    <ng-container *ngIf="lastStatus && lastStatus.base64">
                        <app-singel-document-viewer [isClickable]="true" [imageClass]="'rounded'" [width]="60"
                            [height]="60" [base64]="lastStatus.base64">
                        </app-singel-document-viewer>
                    </ng-container>
                    <span class="mx-2">{{patient.patientCode}}</span>
                    <span>
                        {{translate.currentLang == 'ar' ? patient.titleNameAr : patient.titleNameEn}}{{" /"}}
                        {{translate.currentLang == 'ar' ?
                        patient.fullnameAr ? patient.fullnameAr : patient.patientNameAr
                        :
                        patient.fullnameEn ? patient.fullnameEn : patient.patientNameEn
                        }}
                    </span>
                </div>
                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        {{'accountNo' | translate}}
                    </span>
                    <small class="font-weight-bold">
                        {{ patient.visitSerial}}
                    </small>
                </div>
                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        {{'PATCASE' | translate}}
                    </span>
                    <small class="font-weight-bold">
                        <!-- {{ patient.patCaseType}} -->
                        {{translate.currentLang == 'ar' ? patient.patCaseTypeNameAr : patient.patCaseTypeNameEn}}
                    </small>
                </div>
                <!-- added at 21/1/2020  -->
                <div class="col  d-flex align-items-center mt-2" *ngIf="patient.docNameEn != undefiend">
                    <span class="text-primary mx-2">
                        {{'doctorName' | translate}}
                    </span>
                    <small class="font-weight-bold">
                        {{translate.currentLang == 'ar' ? patient.docNameAr : patient.docNameEn}}
                    </small>
                </div>
                <div class="col  d-flex align-items-center mt-2" (click)="selectAge()">
                    <span class="mx-2" [ngStyle]="{'color': (patient.age==0 || !patient.age)? 'red ' : '#007bff' }">
                        {{'AGE' | translate }}
                    </span>

                    <small class="font-weight-bold">
                        ({{translate.currentLang == 'ar' ? patient.ageAr : patient.ageEn}})
                    </small>
                </div>
                <!-- <div class="col d-flex align-items-center mt-2">
                
                </div> -->
                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        {{'VSWEIGHT' | translate }} :
                    </span>
                    <small class="font-weight-bold">
                        ({{patient.weight}})
                    </small>
                </div>
                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        {{'CURRENTPLACE' | translate }} :
                    </span>
                    <small class="font-weight-bold">
                        {{translate.currentLang == 'ar' ? patient.lastPlacePatientNameAr :
                        patient.lastPlacePatientNameEn}}
                    </small>
                </div>

                <!-- Blood group dont used Here now  -->
                <!-- <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        {{'BloodGroup' | translate }} :
                    </span>
                    <small
                        class="font-weight-bold">{{translate.currentLang == 'ar' ? patient.bloodGroupAr : patient.bloodGroupEn}}</small>
                </div>

                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        {{'RH' | translate }} :
                    </span>
                    <small
                        class="font-weight-bold">{{translate.currentLang == 'ar' ? patient.rhvalueAr : patient.rhvalueEn}}</small>
                </div> -->


                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        {{'MAILADDRESS' | translate }} :
                    </span>
                    <small class="font-weight-bold">
                        {{patient.mailAddress}}
                    </small>
                </div>

                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        <i class="fa fa-2x fa-map-marker"
                            title="{{translate.currentLang == 'ar' ? patient.fullAddressAr : patient.fullAddressEn}}"></i>
                    </span>
                    <small class="font-weight-bold">
                        {{translate.currentLang == 'ar' ? patient.addressAr : patient.addressEn}}
                    </small>
                </div>

                <div *ngIf="patient.drGeneralNotes" class="col  d-flex align-items-center mt-2">
                    <!-- <span class="text-primary mx-2">
                        {{'Religion' | translate }} :
                    </span>
                    <small class="font-weight-bold"> -->
                    <!-- {{patient.religion_name_en}} -->
                    <!-- ({{translate.currentLang == 'ar' ? patient.religion_name_ar : patient.religion_name_en}})

                    </small> -->
                    <span class="text-primary mx-2">
                        {{'DOCTORNOTES' | translate }} :
                    </span>
                    <strong class="font-weight-bold">
                        ({{ patient.drGeneralNotes }})
                    </strong>
                </div>

                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        <i class="fa fa-2x fa-phone"></i>
                    </span>
                    <div class="">
                        <small class="font-weight-bold">{{patient.mobile}}</small>
                    </div>
                </div>
                <!-- <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        <svg *ngIf="patient.allergy==1 " xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><style>svg{fill:#ff0000}</style><path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/></svg>                  
                        <svg  *ngIf="patient.allergy!=1 " xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><style>svg{fill:#000000}</style><path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/></svg>
                    </span>
                        <small class="font-weight-bold" style="color: red;">{{patient.allergy==1 ?('ALLERGY' | translate):('NOALLERGY' | translate)}}</small>
                </div> -->
                <div title="{{patient.allergyToolTip}}" class="col  d-flex align-items-center mt-2"
                    *ngIf="patient.allergy==1 ">
                    <span class="text-primary mx-2">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                            <style>
                                svg {
                                    fill: #ff0000
                                }
                            </style>
                            <path
                                d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                        </svg> </span>
                    <small class="font-weight-bold" style="color: red;">{{'HASALLERGY' | translate}}</small>
                </div>
                <div title="{{patient.allergyToolTip}}" class="col  d-flex align-items-center mt-2"
                    *ngIf="patient.allergy!=1 ">
                    <span class="text-primary mx-2">
                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
                            <style>
                                svg {
                                    fill: #000000
                                }
                            </style>
                            <path
                                d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                        </svg>
                    </span>
                    <small class="font-weight-bold" style="color: #000000;">{{'NOALLERGY' | translate}}</small>
                </div>
                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        <!-- <i class="fa fa-2x fa-phone"></i> -->
                    </span>
                    <div style="color: red;" class="">
                        <small *ngIf="patient.chronic==1" style="font-size: 16px;" placement="bottom"
                            title="{{patient.chronicToolTip}}" class="font-weight-bold">مزمن</small>
                    </div>
                    <div class="">
                        <small *ngIf="!patient.chronic" class="font-weight-bold">غير مزمن</small>
                    </div>
                </div>

                <div class="col  d-flex align-items-center mt-2">
                    <span class="text-primary mx-2">
                        {{'Contract' | translate }} :
                    </span>
                    <small class="font-weight-bold">
                        ({{translate.currentLang == 'ar' ? patient.contractsAr : patient.contractsEn}})
                    </small>
                </div>



                <!-- <div class="col-1 align-right">
          <i class="material-icons collapse" (click)="toggleMenu()" style="cursor:pointer" title="{{toggle? 'More Detail': 'Less Detail'}}">
            {{toggle? 'keyboard_arrow_up': 'keyboard_arrow_down'}}</i>
        </div> -->

                <!------------------------------------------------------------------------------------>
                <!-- <div class="row" *ngIf="!toggle">
      </div> -->








                <!------------------------------------------------------------------------------------>
                <!-- <div class="row" *ngIf="medical==1">
      </div> -->
                <div class="col  d-flex align-items-center mt-2" *ngIf="medical==1  ">
                    <span class="text-primary mx-2">
                        {{'DOCTOR' | translate }} :
                    </span>
                    <small class="font-weight-bold">
                        {{translate.currentLang == 'ar' ? lastStatus.docNameAr : lastStatus.docNameEn}}
                    </small>
                </div>

                <div class="col  d-flex align-items-center mt-2" *ngIf="medical==1">
                    <span class="text-primary mx-2">{{'PLACENAME' | translate }} :</span>
                    <small class="font-weight-bold">{{translate.currentLang == 'ar' ? lastStatus.placeNameAr :
                        lastStatus.placeNameEn}}
                    </small>
                </div>

                <div class="col  d-flex align-items-center mt-2" *ngIf="medical==1">
                    <span class="text-primary mx-2">{{'ALLERGIES' | translate }}</span>
                    <span class="text-danger col" *ngFor="let allegy of allergies">{{allegy.drugNameEn}} </span>
                </div>

                <div class="col  d-flex align-items-center mt-2" *ngIf="medical==1">
                    <span class="text-primary mx-2">BMI :</span>
                    <small class="font-weight-bold">{{lastStatus.bmi}}</small>
                </div>

                <div class="col  d-flex align-items-center mt-2" *ngIf="medical==1">
                    <span class="text-primary mx-2">BSA :</span>
                    <small class="font-weight-bold">{{lastStatus.bsa}}</small>
                </div>

                <div class="col  d-flex align-items-center mt-2 " *ngIf="medical==1 && lastStatus.infection == 1">
                    <span class="mx-2">
                        <img style="width:25px; height:25px;" src="../../../assets/images/Infection.png"
                            alt="Infection Illness" title="This Patient has infection illness" />
                    </span>
                    <div class="text-primary">
                        <span class="font-weight-bold">{{'INFECTION' | translate}}</span>
                    </div>
                </div>

                <div class="col  d-flex align-items-center mt-2 " *ngIf="medical==1 && lastStatus.chronic == 1">
                    <span class="mx-2">
                        <img style="width:40px; height:40px;" src="../../../assets/images/Chronic.png"
                            alt="Chronic Illness" title="This Patient has chronic illness" />
                    </span>
                    <div class="text-primary">
                        <span class="font-weight-bold">{{'CHRONIC' | translate}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row master-form" *ngIf="this.editAge==true"
            [ngStyle]="{'height': showCalenderFlag==true? '322px ' : '' }">

            <div class="col-1">
                <label>
                    {{'APPROXAGE' | translate}}
                </label>
            </div>
            <div class="col-2">
                <input type="number" class="form-control" #approxAge (change)="onChange(approxAge.value)">
            </div>
            <div class="col-1">

                <label>{{'BIRTHDATE' | translate}}</label>
            </div>
            <div class="col-2">

                <div class="input-group input-group-sm">
                    <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" [(ngModel)]="birthDay"
                        ngbDatepicker #d="ngbDatepicker" (ngModelChange)="showCalenderData('change')">
                    <div class="input-group-addon" (click)="d.toggle();showCalender()">
                        <i class="fa fa-calendar"></i>
                    </div>
                    <!-- <input type="date"  class="form-control" placeholder="{{'DATEFORMAT' | translate}}" [formControl]="selectedDay"  (change)="changeDate($event)"> -->

                </div>

            </div>
            <div class="col-1">
                <btns-ctrl [appCodes]="[1]" (clicked)="onClicked($event)"></btns-ctrl>
            </div>
            <!-- <div class="col-2">

                <input class="customDate form-control" placeholder="{{'BIRTHDATE' | translate}}" ngbDatepicker
                    #dp="ngbDatepicker" >
                <div class="input-group-addon" (click)="dp.toggle()">
                    <i class="fa fa-calendar-minus-o" style="right: 25px; top: 7px;"></i>
                </div>
            </div> -->



        </div>
    </div>
</div>